import ReadyToTalk from './ReadyToTalk';

export default ReadyToTalk;
